import React, { useState, useEffect } from 'react';
import { useTheme } from '@emotion/react';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Grid } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { DataGrid } from '@mui/x-data-grid';
import Button from '@mui/material/Button';
import { Chip } from '@mui/material';
import { useMaterialUIController } from "context";
import ReporteEstadoMatriculas from "components/ReporteEstadoMatriculas";
import PDFModal from "components/PDFModal";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { useApi } from "lib/api";
export default function EstadoMatriculas() {
  const [rows, setRows] = useState([]);
  const [sucursales, setSucursales] = useState([]);
  const [sucursalSeleccionada, setSucursalSeleccionada] = useState('');
  const [estadoEntrega, setEstadoEntrega] = useState('Todas');
  const [busquedaChasis, setBusquedaChasis] = useState('');
  const [cargando, setCargando] = useState(false);
  const [mostrarPDFModal, setMostrarPDFModal] = useState(false);
  const [pdfUrl, setPdfUrl] = useState('');

  const [controller] = useMaterialUIController();
  const { nombreNegocio } = controller;
  const { post } = useApi();

  const opcionesEstadoEntrega = [
    { value: 'Todas', label: 'Todas' },
    { value: 'Entregada', label: 'Entregada' },
    { value: 'No Entregada', label: 'No Entregada' }
  ];

  useEffect(() => {
    cargarDatos();
  }, []);

  const cargarDatos = async () => {
    setCargando(true);
    try {
      const { status, data } = await post('/api/consultarmatricula');
      if (status === 200) {
        setSucursales(data["sucursales"] || []);
        procesarDatosMatriculas(data["matriculas2"] || []);
        setCargando(false);
      } else {
        setCargando(false);
        alert('Error al cargar los datos');
      }
    } catch (error) {
      setCargando(false);
      console.error('Error:', error);
      alert('Error al conectar con el servidor');
    }
  };

  /** Parsea JSON de forma segura; si hay contenido extra después del primer objeto, devuelve solo el primero */
  const safeParse = (str) => {
    if (str == null || typeof str !== 'string' || !str.trim()) return null;
    try {
      return JSON.parse(str);
    } catch (e) {
      if (e instanceof SyntaxError && e.message.includes('position')) {
        let depth = 0;
        let inString = false;
        let escape = false;
        let end = -1;
        for (let i = 0; i < str.length; i++) {
          const c = str[i];
          if (escape) { escape = false; continue; }
          if (c === '\\' && inString) { escape = true; continue; }
          if (!inString && (c === '"' || c === "'")) { inString = c; continue; }
          if (inString && c === inString) { inString = false; continue; }
          if (!inString) {
            if (c === '{' || c === '[') depth++;
            else if (c === '}' || c === ']') { depth--; if (depth === 0) { end = i + 1; break; } }
          }
        }
        if (end > 0) return JSON.parse(str.slice(0, end));
      }
      console.warn('safeParse failed:', str?.slice(0, 100), e);
      return null;
    }
  };

  const procesarDatosMatriculas = (datos) => {
    const datosProcesados = datos.map((item, index) => {
      console.log("item",index,item);
      let sucursalactual = [];
      let cajeroentregado = [];
      let fechasentrega = []
      if (item.sucursaldocumentos) {
        const sucDoc = safeParse(item.sucursaldocumentos);
        const docStr = sucDoc?.documentos;
        if (docStr != null && String(docStr).includes('*')) {
          const documentos = String(docStr).split('*').filter(Boolean);
          documentos.forEach(doc => {
            const parsed = safeParse(doc);
            if (parsed?.sucursalrecep && sucursalactual.indexOf(parsed.sucursalrecep.split('-')[1]) === -1) {
              sucursalactual.push(parsed.sucursalrecep.split('-')[1]);
            }
          });
        } else if (docStr != null) {
          const documentos = safeParse(docStr);
          if (documentos?.sucursalrecep) {
            sucursalactual = documentos.sucursalrecep.split('-')[1];
          }
        }

        if (item.cajeromatriculaentregada) {
          const cajeroData = safeParse(item.cajeromatriculaentregada);
          if (cajeroData != null) {
            if (typeof cajeroData === 'string' && cajeroData.includes('*')) {
              const documentosentregados = cajeroData.split('*').filter(Boolean);
              documentosentregados.forEach(doc => {
                const parsed = safeParse(doc);
                if (parsed && cajeroentregado.indexOf(parsed.cajero) === -1) {
                  cajeroentregado.push(parsed.cajero);
                  fechasentrega.push(parsed.fecha);
                }
              });
              cajeroentregado = cajeroentregado.join(',');
              fechasentrega = fechasentrega.join(',');
            } else if (typeof cajeroData === 'object') {
              cajeroentregado = cajeroData.cajero;
              fechasentrega = cajeroData.fecha;
            }
          }
        } else {
          const statusfechaentrega = "No Asignada";
        }
        return{
          id: index + 1,
          chasis: item.chasis || '',
          placa: item.placa || 'Sin placa',
          sucursal: item.localizacion || 'No especificada',
          estadoEntrega: 'Entregada',
          fechaEntrega: fechasentrega || '',
          nombreRecibio: cajeroentregado || '',
          apellidoRecibio: item.apellidosmatriculaentregada || '',
          cedulaRecibio: item.cedulamatriculaentregada || '',
          sucursalEntrega: sucursalactual || '',
          cajero: cajeroentregado || '',
          endoso: item.endoso || '',
          documentos: item.sucursaldocumentos || ''
        }
      }
      
      if (!item.sucursaldocumentos) {
        return{
          id: index + 1,
          chasis: item.chasis || '',
          placa: item.placa || 'Sin placa',
          sucursal: item.localizacion || 'No especificada',
          estadoEntrega: 'No Entregada',
          fechaEntrega: item.fechamatriculaentregada || '',
          nombreRecibio: 'No Recibido' || '',
          apellidoRecibio: item.apellidosmatriculaentregada || '',
          cedulaRecibio: item.cedulamatriculaentregada || '',
          sucursalEntrega: "No Asignada" || '',
          cajero: item.cajeromatriculaentregada || '',
          endoso: item.endoso || '',
          documentos: item.sucursaldocumentos || ''
        }
      }
      

    });

    setRows(datosProcesados);
  };

  const filtrarDatos = () => {
    let datosFiltrados = rows;
    
    // Filtrar por chasis
    if (busquedaChasis && busquedaChasis.trim() !== '') {
      datosFiltrados = datosFiltrados.filter(item => 
        item.chasis.toLowerCase().includes(busquedaChasis.toLowerCase())
      );
    }
    
    // Filtrar por sucursal
    if (sucursalSeleccionada && sucursalSeleccionada !== 'Todas') {
      datosFiltrados = datosFiltrados.filter(item => 
        item.sucursal.includes(sucursalSeleccionada.split('-')[0])
      );
    }

    // Filtrar por estado de entrega
    if (estadoEntrega !== 'Todas') {
      datosFiltrados = datosFiltrados.filter(item => 
        item.estadoEntrega === estadoEntrega
      );
    }

    return datosFiltrados;
  };

  const datosFiltrados = filtrarDatos();

  const generarPDF = () => {
    const filtros = {
      sucursal: sucursalSeleccionada,
      estadoEntrega: estadoEntrega,
      busquedaChasis: busquedaChasis
    };
    
    const pdfUrl = ReporteEstadoMatriculas.generarReporteParaModal(datosFiltrados, filtros);
    setPdfUrl(pdfUrl);
    setMostrarPDFModal(true);
  };

  const descargarPDF = () => {
    const filtros = {
      sucursal: sucursalSeleccionada,
      estadoEntrega: estadoEntrega,
      busquedaChasis: busquedaChasis
    };
    
    ReporteEstadoMatriculas.generarReporte(datosFiltrados, filtros);
  };

  const columns = [
    {
      field: 'chasis',
      headerName: 'Chasis',
      width: 175,
      renderCell: (params) => (
        <Typography variant="body2" fontWeight="bold">
          {params.value}
        </Typography>
      ),
    },
    {
      field: 'placa',
      headerName: 'Placa',
      width: 120,
      renderCell: (params) => (
        <Typography variant="body2" color={params.value === 'Sin placa' ? 'text.secondary' : 'primary'}>
          {params.value}
        </Typography>
      ),
    },
    {
      field: 'sucursal',
      headerName: 'Localizacion',
      width: 150,
    },
    {
      field: 'estadoEntrega',
      headerName: 'Estado Entrega',
      width: 140,
      renderCell: (params) => (
        <Chip
          label={params.value}
          color={params.value === 'Entregada' ? 'success' : 'warning'}
          size="small"
          variant="outlined"
        />
      ),
    },
    {
      field: 'fechaEntrega',
      headerName: 'Fecha Entrega',
      width: 120,
      renderCell: (params) => (
        <Typography variant="body2">
          {params.value ? new Date(params.value).toLocaleDateString() : 'No entregada'}
        </Typography>
      ),
    },
    {
      field: 'nombreRecibio',
      headerName: 'Recibido Por',
      width: 200,
      renderCell: (params) => (
        <Box>
          <Typography variant="body2">
            {params.row.nombreRecibio} {params.row.apellidoRecibio}
          </Typography>
          {params.row.cedulaRecibio && (
            <Typography variant="caption" color="text.secondary">
              Cédula: {params.row.cedulaRecibio}
            </Typography>
          )}
        </Box>
      ),
    },
    {
      field: 'sucursalEntrega',
      headerName: 'Sucursal Entrega',
      width: 150,
    },
    {
      field: 'cajero',
      headerName: 'Cajero',
      width: 150,
    },
    {
      field: 'endoso',
      headerName: 'Endoso',
      width: 150,
      renderCell: (params) => (
        <Typography variant="body2">
          {params.value || 'No'}
        </Typography>
      ),
    }
  ];

  const estadisticas = {
    total: datosFiltrados.length,
    entregadas: datosFiltrados.filter(item => item.estadoEntrega === 'Entregada').length,
    noEntregadas: datosFiltrados.filter(item => item.estadoEntrega === 'No Entregada').length
  };

  return (
    <Box>
      <Box py={3}>
        <Grid container spacing={3}>
          {/* Filtros */}
          <Grid item xs={12}>
            <Box sx={{ p: 2, bgcolor: 'background.paper', borderRadius: 1, mb: 2 }}>
              <Typography variant="h6" gutterBottom>
                Filtros de Búsqueda
              </Typography>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} md={3}>
                  <TextField
                    label="Buscar por Chasis"
                    variant="outlined"
                    fullWidth
                    value={busquedaChasis}
                    onChange={(e) => setBusquedaChasis(e.target.value)}
                    placeholder="Ingrese número de chasis"
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <Autocomplete
                    options={['Todas', ...sucursales.map(s => s.label)]}
                    value={sucursalSeleccionada}
                    onChange={(event, newValue) => setSucursalSeleccionada(newValue || 'Todas')}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Seleccionar Sucursal"
                        variant="outlined"
                        fullWidth
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <Autocomplete
                    options={opcionesEstadoEntrega}
                    value={opcionesEstadoEntrega.find(op => op.value === estadoEntrega)}
                    onChange={(event, newValue) => setEstadoEntrega(newValue?.value || 'Todas')}
                    getOptionLabel={(option) => option.label}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Estado de Entrega"
                        variant="outlined"
                        fullWidth
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} md={1}>
                  <Button
                    variant="contained"
                    onClick={cargarDatos}
                    disabled={cargando}
                    sx={{ width: '100%', color: 'white' }}
                    style={{ color: 'white' }}
                  >
                    {cargando ? 'Cargando...' : 'Actualizar'}
                  </Button>
                </Grid>
                <Grid item xs={12} md={1}>
                  <Button
                    variant="contained"
                    color="success"
                    onClick={generarPDF}
                    disabled={cargando || datosFiltrados.length === 0}
                    startIcon={<PictureAsPdfIcon />}
                    sx={{ width: '100%' }}
                  >
                    Ver PDF
                  </Button>
                </Grid>
                <Grid item xs={12} md={1}>
                  <Button
                    variant="contained"
                    color="info"
                    onClick={descargarPDF}
                    disabled={cargando || datosFiltrados.length === 0}
                    startIcon={<PictureAsPdfIcon />}
                    sx={{ width: '100%' }}
                  >
                    Descargar PDF
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Grid>

          {/* Estadísticas */}
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4}>
                <Box sx={{ p: 2, bgcolor: 'primary.main', color: 'white', borderRadius: 1, textAlign: 'center' }}>
                  <Typography variant="h4" style={{color: 'white'}}>{estadisticas.total}</Typography>
                  <Typography variant="body2" style={{color: 'white'}}>Total Matrículas</Typography>
                </Box>
              </Grid>
              <Grid item xs={12} md={4}>
                <Box sx={{ p: 2, bgcolor: 'success.main', color: 'white', borderRadius: 1, textAlign: 'center' }}>
                  <Typography variant="h4" style={{color: 'white'}}>{estadisticas.entregadas}</Typography>
                  <Typography variant="body2" style={{color: 'white'}}>Entregadas</Typography>
                </Box>
              </Grid>
              <Grid item xs={12} md={4}>
                <Box sx={{ p: 2, bgcolor: 'warning.main', color: 'white', borderRadius: 1, textAlign: 'center' }}>
                  <Typography variant="h4" style={{color: 'white'}}>{estadisticas.noEntregadas}</Typography>
                  <Typography variant="body2" style={{color: 'white'}}>No Entregada</Typography>
                </Box>
              </Grid>
            </Grid>
          </Grid>

          {/* Tabla de datos */}
          <Grid item xs={12}>
            <Box sx={{ height: 600, width: '100%' }}>
              <DataGrid
                rows={datosFiltrados}
                columns={columns}
                pageSize={10}
                rowsPerPageOptions={[10, 25, 50]}
                disableSelectionOnClick
                loading={cargando}
                sx={{
                  '& .MuiDataGrid-cell': {
                    borderBottom: '1px solid #f0f0f0',
                  },
                  '& .MuiDataGrid-columnHeaders': {
                    backgroundColor: '#f5f5f5',
                    fontWeight: 'bold',
                  },
                }}
              />
            </Box>
          </Grid>
        </Grid>

        {/* Modal PDF */}
        <PDFModal
          open={mostrarPDFModal}
          onClose={() => setMostrarPDFModal(false)}
          pdfUrl={pdfUrl}
          title="Reporte de Estado de Matrículas"
          showDownloadButton={true}
          showPrintButton={true}
        />
      </Box>
    </Box>
  );
}
